import React from 'react';
import * as S from './PaymentBlockLoader.styles';

const PaymentBlockLoader = () => {
  return (
    <S.PaymentBlockLoader>
      <S.HeaderWithIconWrap>
        <S.PaymentBlockHeader></S.PaymentBlockHeader>
        <S.ArrowDownWrap>
          <S.ArrowDown></S.ArrowDown>
        </S.ArrowDownWrap>
      </S.HeaderWithIconWrap>
    </S.PaymentBlockLoader>
  );
};

export default PaymentBlockLoader;
